import { render, staticRenderFns } from "./FosteringCultureInnovation.vue?vue&type=template&id=7be67d4f&scoped=true&"
import script from "./FosteringCultureInnovation.vue?vue&type=script&lang=js&"
export * from "./FosteringCultureInnovation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be67d4f",
  null
  
)

export default component.exports